document.addEventListener('chartjs:init', function (event) {
    function cssVar(name) {
        return getComputedStyle(document.documentElement).getPropertyValue(name);
    }

    const Chart    = event.detail.Chart;
    const defaults = Chart.defaults;

    defaults.font.family = "'InterVariable', 'Inter Variable', 'Inter', sans-serif";

    function setColors() {
        defaults.borderColor              = cssVar('--chartjs-border-color');
        defaults.elements.arc.borderColor = cssVar('--chartjs-arc-border-color');
    }

    // initialize
    setColors();

    // redraw after dark mode toggle
    window.addEventListener('website:mode:change', () => {
        setColors();
        Object.values(Chart.instances).forEach(instance => instance.update());
    });
});
